<template>
<div class="chapter">
<div class="inner_page">
<h1>Sommario</h1>
<p><span href="#/c001" title="Link target outside of Sample">Titolo Pagina</span></p>
<p><span href="#/c002" title="Link target outside of Sample">Copyright Pagina</span></p>
<p><a href="#/c003">Guida completa per comprendere le Dommes della Cina continentale</a></p>
<p><a href="#/c004">Guida completa per | comprendere le Dommes della Cina continentale...</a></p>
<p><a href="#/c005">DICHIARAZIONE DI NON RESPONSABILITÀ</a></p>
<p><a href="#/c006">Citazioni famose</a></p>
<p><span href="#/c007" title="Link target outside of Sample">I CONSIGLI</span></p>
<p><span href="#/c008" title="Link target outside of Sample">Altro su queste belle signore cinesi</span></p>
<p><span href="#/c009" title="Link target outside of Sample">APERTURA MENTALE?</span></p>
<p><span href="#/c010" title="Link target outside of Sample">GRAZIE.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?4ad478e6